<template>
  <b-row>
    <b-col md="12">
        <b-alert v-for="(errors, id) in response.errors" :key="id" :show="dismissCountDown"
                  dismissible
                  :variant="response.success== true ? 'success':'danger'"
                  @dismissed="dismissCountdown=0"
                  @dismiss-count-down="countDownChanged">
            <p v-if="response.errors" style="font-size:13px;margin-bottom: 0;"><b>{{ id }}</b> : <span v-for="(error, index) in errors" :key="index"><br>{{ error }}</span></p>
           <strong v-if="!response.errors">{{response.message}}</strong>
        </b-alert>
        <b-alert v-if="!response.errors" :show="dismissCountDown"
                  dismissible
                  :variant="response.success== true ? 'success':'danger'"
                  @dismissed="dismissCountdown=0"
                  @dismiss-count-down="countDownChanged">
           <strong v-if="!response.errors">{{response.message}}</strong>
        </b-alert>
        
        <b-card>
          <div slot="header" v-if="display_entity">
            Ajout d'un <strong>utilisateur</strong>  
          </div>
          <div slot="header" v-if="!display_entity">
            Création d'un agent <strong>{{ entite_name }}</strong>  
          </div>
          <b-row class="form-group">
            <b-col md="6">
              <label for="nom">Nom *</label>
              <b-form-input id="nom" type="text" v-model="user.name" placeholder="Nom complet de l'agent" ></b-form-input>
            </b-col>
            <b-col md="6">
              <label for="email">Email *</label>
              <b-form-input type="email" v-model="user.email" placeholder="Email de l'utilisateur" id="email"></b-form-input>
            </b-col>    
            
            
          </b-row>
          <b-row class="form-group">
            <b-col md="6">
              <label for="role">Role *</label>
              <select id="role" :plain="true" v-model="user.roles" class="form-control" @change="choose_code" :disabled="grise_element == true" v-if="isAdmin">
                <option v-for="option in options_roles" v-bind:value="option.value">
                  {{ option.text }}
                </option>
              </select>
              <el-select v-model="user.roles" filterable multiple placeholder="Selectionnez les différents roles" style="width:100%;" :disabled="grise_element == true" v-if="!isAdmin">
                <el-option
                  v-for="item in options_roles"
                  :key="item.value"
                  :label="item.text"
                  :value="item.value">
                </el-option>
              </el-select>
            </b-col>
            <!-- <b-col md="6" v-if="display_entity">
              <label for="entite_id">Entite *</label>
              <b-form-select id="entite_id" :plain="true" :options="options" v-model="user.entite_id">
              </b-form-select>
            </b-col> -->
            <b-col md="6" v-if="display_entity">
              <label for="entite_id">Entite *</label>
                <el-select style="display:block;"
                  id="entite_id"
                  v-model="user.entite_id"
                  loading-text="Chargement en cours"
                  no-match-text="Entité non trouvée"
                  no-data-text="Aucune données trouvées"
                  size="small"
                  filterable
                  remote
                  reserve-keyword
                  placeholder="Rechercher le nom de votre entité"
                  :remote-method="remoteEntities"
                  :loading="loading">
                  <el-option
                    v-for="item in options4"
                    :key="item.value"
                    :label="item.text"
                    :value="item.value">
                  </el-option>
                </el-select>
              </b-col>
            <!-- <b-col md="6" v-if="display_agency">
              <label for="agence_id">Agence *</label>
              <b-form-select id="agence_id" :plain="true" :options="options_agency" v-model="user.agence_id">
              </b-form-select>
            </b-col> -->
            <b-col md="6" v-if="display_agency">
              <label for="agence_id">Agence *</label>
                <el-select style="display:block;"
                  v-model="user.agence_id" id="agence_id"
                  loading-text="Chargement en cours"
                  no-match-text="Agence non trouvée"
                  no-data-text="Aucune données trouvées"
                  size="small"
                  filterable
                  remote
                  reserve-keyword
                  placeholder="Rechercher le nom de votre agence"
                  :remote-method="remoteAgencies"
                  :loading="loading">
                  <el-option
                    v-for="item in options5"
                    :key="item.value"
                    :label="item.text"
                    :value="item.value">
                  </el-option>
                </el-select>
            </b-col>
          </b-row>
          <b-row class="form-group">
            
            <b-col md="6">
              <b-form-group label="Mot de passe *" label-for="elementsAppendButton" description="Votre mot de passe doit contenir au moins 8 caractères, un chiffre,un caractère spécial, MAJ-min">
              <b-input-group>
                <b-form-input :type="class_password.type" v-model="user.password" placeholder="Mot de passe de l'utilisateur" id="password"></b-form-input>
                <b-input-group-append>
                  <b-button variant="primary" @click.prevent="see()" style="width:40px;height:35px;"><i :class="class_password.icon"></i></b-button>
                </b-input-group-append>
              </b-input-group>
            </b-form-group>
            </b-col>
            <b-col md="6">
              <b-form-group label="Confirmation du mot de passe *" label-for="elementsAppendButton" :description="class_password.text">
                <b-input-group>
                  <input type="password" class="form-control" v-model="user.password_confirmation" placeholder="Mot de passe de l'utilisateur" id="pass" @keyup="confirmation()"/>
                </b-input-group>
              </b-form-group>
            </b-col>
            <!-- <b-col md="6">
              <label for="solde">Mot de passe *</label>
              <b-form-input type="password" v-model="user.password" placeholder="Mot de passe de l'utilisateur"></b-form-input>
            </b-col> -->
            
          </b-row>
          <div slot="footer">
            <span v-if="can('user-create')"><b-button type="submit" size="sm" variant="primary" @click.prevent="post()"><i class="fa fa-dot-circle-o"></i> Valider</b-button></span>
            <b-button type="reset" @click="goBack" size="sm" variant="danger"><i class="fa fa-ban"></i> Annuler </b-button>
          </div>
        </b-card>    
    </b-col>
  </b-row>
</template>

<script>

export default {
  name: 'tables',
  data(){
    return {
      isAdmin:false,
      userConnected:{},
      dismissSecs: 10,
      dismissCountDown: 0,
      showDismissibleAlert: false,
      response:{},
      display_entity :false,
      display_agency :false,
      options : [],
      t : [],
      options_agency : [],
      options_roles : [],
      user:{
        name: '',
        roles: '',
        email: '',
        clienturl:url_redirect,
        password: '',
        password_confirmation: '',
        entite_id: null,
        agence_id: null,
      },

      entities:[],
      agencies:[],
      entite_name :'',
      grise_element:false,
      view_passord : false,
      class_password : {
        icon : "fa fa-eye",
        type : 'password',
        text:''
      },
      value1: [],
      value2: [],


      options4: [],
      options5: [],
        value9: [],
        list: [],
        loading: false,
        states: []
    }
  },
  methods:{
    
    countDownChanged (dismissCountDown) {
        this.dismissCountDown = dismissCountDown
    },
    showAlert () {
      this.dismissCountDown = this.dismissSecs
    },
    can(perm){
        return store.getters['auth/can'](perm)
    },
    see(){
        if (this.view_passord==false){
            this.class_password.icon ="fa fa-eye"
            this.class_password.type ="password"
            this.view_passord = true
        }else{
            this.class_password.icon ="fa fa-eye-slash"
            this.class_password.type ="text"
            this.view_passord = false
        }
    },
    confirmation(){
        if(this.user.password != this.user.password_confirmation){
          this.class_password.text = "Le mot de passe et le mot de passe de confirmation sont incorrects"
        }else{
          this.class_password.text = "Correct !"
        }
    },
    async post(){     

        this.response = await this.$store.dispatch('user/post_users',this.user)
        this.showAlert() 
        if (this.response.success==true){
          this.reset()
        }
    },
    async get_all_entities(query){
      
      if(this.$route.params.entite_id === null || this.$route.params.entite_id === 'null'){
          this.userConnected = await store.getters['auth/get_user']
          if (this.userConnected.role.toUpperCase() == 'SUPER ADMIN'){
               this.display_entity = true
               this.display_agency = false
              let serverParams= {
                page:1,
                current_page: 1,
                paginate: 10,
                nom_commercial: query,
              }
              await this.$store.dispatch('entity/get_all_entities',serverParams).then(()=>{
                return this.entities = store.getters['entity/rows'];    
              })
              this.entities.forEach((element)=>{
                  this.options.push({
                    value:element.id,
                    text:element.nom_commercial.toUpperCase(),
                  })
              })
              this.t = this.options
          }else{
              
              this.display_entity =  false
              this.display_agency =true
              let serverParams= {
                page:1,
                current_page: 1,
                paginate: 10
              }
              await this.$store.dispatch('agency/get_all_agenciesOwn',serverParams).then(()=>{
                return this.agencies = store.getters['agency/rows'];    
              })
              this.agencies.forEach((element)=>{
                  this.options_agency.push({
                    value:element.id,
                    text:element.nom_agence.toUpperCase(),
                  })
              })
              await this.$store.dispatch('entity/get_all_authentites',serverParams).then(()=>{
                return this.entities = store.getters['entity/rows'];    
              })
              this.entities.forEach((element)=>{
                  this.options.push({
                    value:element.id,
                    text:element.nom_commercial.toUpperCase(),
                  })
              })
          }
          //this.entities =  store.getters['entity/rows'];
          
            
            if(this.options.length==1){
                this.user.entite_id = this.options[0].value
            }
          }else{         
          this.display_entity = false
          this.user.entite_id = this.$route.params.entite_id
          await this.$store.dispatch('entity/show_entites',this.user.entite_id).then((res)=>{
            return this.entite_name = res.nom_commercial
          })
          this.options.push({
            value:this.$route.params.entite_id,
            text:this.$route.params.entite_id
          })
      }

    },
    choose_code(){

      if(this.user.roles.toUpperCase()==="CHEF AGENCE"){
        this.display_agency=true
        this.display_entity =false
      }else if(this.user.roles.toUpperCase()==="RESPONSABLE POSTE" || this.user.roles.toUpperCase()==="RESPONSABLE DISTRIBUTEUR" || this.user.roles.toUpperCase()==="CENTRE APPEL"){
        this.display_agency=false
        this.display_entity =true
      }else{
        this.display_agency=true
        this.display_entity =false
      }
    },
    // async findRoles(role){
    //   await this.$store.dispatch('role/get_all_roles').then(()=>{
    //       store.getters['role/rows'].forEach(element => {
    //         this.options_roles.push({
    //           value:element.name,
    //           text:element.name.toUpperCase()
    //         })
    //       });
    //     })
    //   this.options_roles.fin
    // },get_roles_by_entite
    async get_all_roles(){
     if(this.$route.params.entite_id === null || this.$route.params.entite_id === 'null'){
        this.param_role = null
     }else{this.param_role=this.$route.params.entite_id}
      await this.$store.dispatch('role/get_roles_by_entite',{entite_id:this.param_role}).then(()=>{
        store.getters['role/rows'].forEach(element => {
          this.options_roles.push({
            value:element.name,
            text:element.name.toUpperCase()
          })
        });
      }) 
      if(this.options_roles.length==1){
        this.user.roles = this.options_roles[0].value
          console.log('taille :',this.options_roles[0]) 
          this.grise_element = true
      }
      // }else{
      //    await this.$store.dispatch('role/get_roles_by_entite').then(()=>{
      //     store.getters['role/rows'].forEach(element => {
      //       console.log('role element ',element)
      //       this.options_roles.push({
      //         value:element.name,
      //         text:element.name.toUpperCase()
      //       })
      //     });
      //   }) 
     // }
    },
    async get_user(){
        this.userConnected = await store.getters['auth/get_user']
        return this.userConnected 
    },
    reset(){
      this.user.name= '',
      this.user.roles= '',
      this.user.email= '',
      this.user.password= '' 
      this.user.password_confirmation= '' 
    },
    goBack() {
      this.$router.go(-1)
    },
    async get_user_c(){
        this.res = await store.getters['auth/get_user']
        console.log(this.res.role)
        if(this.res.role.toUpperCase() == "SUPER ADMIN"){
            this.isAdmin=true
            }
            return this.res
    },
    remoteEntities(query) {
        this.get_all_entities(query)
        console.log("ma requete 1",this.t)
        if (query !== '') {
          this.loading = true;
          setTimeout(() => {
            this.loading = false;
            this.options4 = this.t.filter(item => {
              return item.text.toLowerCase()
                .indexOf(query.toLowerCase()) > -1;
            });
          }, 200);
          console.log("ma requete 2 ",this.t)
        } else {
          this.options4 = [];
        }
        this.options = [] 
        // console.log("ma requete 3 ",this.options)
    },
    remoteAgencies(query) {
        if (query !== '') {
          this.loading = true;
          setTimeout(() => {
            this.loading = false;
            this.options5 = this.options_agency.filter(item => {
              return item.text.toLowerCase()
                .indexOf(query.toLowerCase()) > -1;
            });
          }, 200);
        } else {
          this.options5 = [];
        }
    }
  },
  mounted(){
    // this.list = this.states.map(item => {
    //     return { value: item, label: item };
    //   });
    console.log("mes options ",url_redirect)
    this.get_user()
    this.get_user_c()
    this.get_all_entities('')
    this.get_all_roles()
  }
}
</script>
